/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { OpportunityEntity } from './opportunity-entity';
import { UserEntity } from './user-entity';
export class OpportunityCollaboratorEntity extends Entity {
  collaboratorId: string | null = null;
  createdAt: string | null = null;
  id: string = '';
  opportunity: OpportunityEntity | null = null;
  opportunityId: string | null = null;
  updatedAt: string | null = null;
  user: UserEntity | null = null;
  static override key = 'OpportunityCollaborator';
  static override get schema() {
    return {
      opportunity: OpportunityEntity,
      user: UserEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'OpportunityCollaborator' in input
    ) {
      const { OpportunityCollaborator: wrapped, ...rest } = input as {
        OpportunityCollaborator: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}